module.exports = __webpack_public_path__ + "static/img/animales_22.6e45af1e.jpg";